var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  require("!!vue-style-loader!css-loader!../node_modules/.13.0.4@vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-6677980b\",\"scoped\":false,\"hasInlineConfig\":false}!less-loader?{\"globalVars\":{\"museUiTheme\":\"'/Users/jiayihu/jiayi/projects/v-verify/node_modules/muse-ui/src/styles/themes/variables/green.less'\"}}!../node_modules/.13.0.4@vue-loader/lib/selector?type=styles&index=0!./App.vue")
  require("!!vue-loader/node_modules/vue-style-loader!css-loader?sourceMap!../node_modules/.13.0.4@vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-6677980b\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader!@/assets/style/basic.scss")
  require("!!vue-loader/node_modules/vue-style-loader!css-loader?sourceMap!../node_modules/.13.0.4@vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-6677980b\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader!@/assets/style/example.scss")
}
var normalizeComponent = require("!../node_modules/.13.0.4@vue-loader/lib/component-normalizer")
/* script */
import __vue_script__ from "!!babel-loader!../node_modules/.13.0.4@vue-loader/lib/selector?type=script&index=0!./App.vue"
/* template */
import __vue_template__ from "!!../node_modules/.13.0.4@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6677980b\",\"hasScoped\":false}!../node_modules/.13.0.4@vue-loader/lib/selector?type=template&index=0!./App.vue"
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "example/App.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] App.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-loader/node_modules/vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6677980b", Component.options)
  } else {
    hotAPI.reload("data-v-6677980b", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./example/App.vue
// module id = 223
// module chunks = 5